import React, { useState } from "react";
import {
  EditableTextField,
  EditableSelectField,


} from "../../../../../Global_Component/CustomInputComponent";



import { Box, Grid, Typography,Button } from "@mui/material";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../../Global_Component/GlobalButtonComponent";




const MenuListingClient = () => {
  const [noOfProduct, setNoOfProduct] = useState([
    "Product1",
    "Product2",
    
   
  ]);

  function addMoreProduct() {
    setNoOfProduct([...noOfProduct, `Product${noOfProduct.length + 1}`]);
  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#fff",
        height: "auto",
      
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Menu Listing
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          height: "auto",
       
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          {noOfProduct.map((data, index) => (
            <Grid
              container
              key={index}
              sx={{
                borderBottom: "1px solid #ccc", // Optional for row distinction
                p: 1,
                m: 0,
              }}
            >
              <Grid item xs={12} sx={{ p: 0, m: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#313131",
                    fontWeight: 500,
                    lineHeight: 1.5, // Adjust line height
                    p: 0,
                    m: 0,
                  }}
                >
                  {data}
                </Typography>
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="name"
                  label="Product Name / Dish Name"
                  value=""
                  isEdit={true}
                />
              </Grid>


              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="usage"
                  label="Category"
                  value=""
                
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="price"
                  label="Price"
                  value=""
                  isEdit={true}
                />
              </Grid>

             
            </Grid>
          ))}
        </Grid>
      </Box>

      <Grid
        xs={12}
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-stat",
          gap: 1,
          borderTop: "1px solid gray",
        }}
      >
        <Grid md={"10"}>
            <Button onClick={addMoreProduct}>Add more Product</Button>
        </Grid>
        <Grid md={"12"} sx={{ display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          }}>
        <CustomSecondaryButton label={"Back"} sx={{ margin: 2 }} />
        <CustomSuccessButton label={"Next"} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MenuListingClient;
